import { render, staticRenderFns } from "./UserFacilityPermissionModal.vue?vue&type=template&id=9d31a548&scoped=true"
import script from "./UserFacilityPermissionModal.vue?vue&type=script&lang=js"
export * from "./UserFacilityPermissionModal.vue?vue&type=script&lang=js"
import style0 from "./UserFacilityPermissionModal.vue?vue&type=style&index=0&id=9d31a548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d31a548",
  null
  
)

export default component.exports